<div class="section_3">
  <div class="section-header">
    <ng-container i18n>Integrated with leading channel managers</ng-container>
  </div>
  <div class="section-content">
    <ng-container i18n>We are already integrated with the leading channel managers in the hostel industry, ensuring a seamless and convenient experience for hostels like yours. No extra work required - just sign up and start boosting your bookings through our platform.</ng-container>
  </div>
</div>

<div class="logos" #scroller infiniteScroll
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="50"
  [horizontal]="true"
  (scroll)="onScroll($event)"
  [scrollWindow]="false">
  <ng-container *ngFor="let logo of logos">
    <div class="logo logo-negative" [ngClass]="logo.name">
      <img ngOptimizedImage [ngSrc]="logo.url" [alt]="logo.name" [fill]="true">
    </div>
  </ng-container>
</div>

<div class="btn-container">
  <a [routerLink]="['/help']" fragment="talk-to-us" class="btn btn-frame btn-frame-negative btn-large">
    <ng-container>
      <span>Don't see your channel manager?<span *hostelHopIfBreakpoint="('desktop' | breakpointAlias)"> Contact us</span></span>
    </ng-container>
  </a>
</div>

